import { Search } from "lucide-react";
import { Input } from "components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { Switch } from "components/ui/switch";
import { Label } from "components/ui/label";

const SORT_OPTIONS = [
  { value: "asc", label: "A-Z" },
  { value: "desc", label: "Z-A" },
  { value: "createdAt", label: "Date Created" },
  { value: "updatedAt", label: "Most Recently Used" },
];

const FilterNav = ({
  sortOrder,
  setSortOrder,
  activeOnly,
  setActiveOnly,
  searchQuery,
  setSearchQuery,
}) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex flex-wrap items-center gap-3 flex-1 min-w-0">
        <Select
          value={sortOrder || undefined}
          onValueChange={(v) => setSortOrder(v)}
        >
          <SelectTrigger className="w-[160px] bg-background text-sm">
            <SelectValue placeholder="Sort By" />
          </SelectTrigger>
          <SelectContent>
            {SORT_OPTIONS.map((o) => (
              <SelectItem key={o.value} value={o.value}>
                {o.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <div className="relative w-full sm:max-w-xs flex-1 min-w-[160px]">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            type="text"
            value={searchQuery ?? ""}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search AI Agents"
            className="h-10 !pl-9 text-sm rounded-md"
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Switch
          id="active-agents"
          checked={activeOnly}
          onCheckedChange={(checked) => setActiveOnly(checked)}
          aria-label="Toggle active agents"
        />
        <Label htmlFor="active-agents" className="text-sm font-medium cursor-pointer">
          Active Agents
        </Label>
      </div>
    </div>
  );
};

export default FilterNav;
